import { COLUMNS_DETALLE_POR_CEREAL_LINEA_4, COLUMNS_DETALLE_POR_CEREAL_LINEA_4_TO_PRINT } from './constantesDetallePorCerealLinea4'
import { TABLA_DETALLE_POR_CEREAL_LINEA_4 } from '../../../../../config/tables'
import { TablaDetallePorCerealLinea4Service } from '../../../../../models/movimiento/distribucionDetallePorCereal/Tabla_detalle_por_cereal_linea_4'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CEREAL_LINEA_4
    })
    const promiseTablaDetallePorCerealLinea4 = TablaDetallePorCerealLinea4Service.getDataTablaDetallePorCerealLinea4()
    const promiseTablaDetallePorCerealLinea4Total = TablaDetallePorCerealLinea4Service.getDataTablaDetallePorCerealLinea4Total()
    Promise.all([promiseTablaDetallePorCerealLinea4, promiseTablaDetallePorCerealLinea4Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Cereal Sector 4',
        dataCombinada,
        COLUMNS_DETALLE_POR_CEREAL_LINEA_4_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CEREAL_LINEA_4,
          data: dataCombinada,
          title: `Distribución Por Cereal Sector 4`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_DETALLE_POR_CEREAL_LINEA_4
      })
    }
  }
}
